import React from 'react'
import { Row, Col } from 'rsuite'

export default function ProjectNameView({ schema }) {
  const emptyValue = <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>

  return (
    <>
      <Row>
        {schema.projectNameTH && (
          <Col>
            <p>{schema.projectNameTH.value ? schema.projectNameTH.value : '- ไม่ระบุ -'}</p>
          </Col>
        )}

        {schema.projectNameEN && (
          <Col>
            <p>{schema.projectNameEN.value && '( ' + schema.projectNameEN.value + ' )'}</p>
          </Col>
        )}

        {schema.projectName && (
          <Col>
            <p>
              {schema.projectVar1 ? schema.projectVar1.label : ''}{' '}
              {schema.projectVar1 ? <u> {schema.projectVar1.value || emptyValue} </u> : ''}{' '}
              {schema.projectVar2 ? schema.projectVar2.label : ''}{' '}
              {schema.projectVar2 ? <u> {schema.projectVar2.value || emptyValue} </u> : ''}{' '}
              {schema.projectVar3 ? schema.projectVar3.label : ''}{' '}
              {schema.projectVar3 ? <u> {schema.projectVar3.value || emptyValue} </u> : ''}{' '}
              {schema.projectVar4 ? schema.projectVar4.label : ''}{' '}
              {schema.projectVar4 ? <u> {schema.projectVar4.value || emptyValue} </u> : ''}{' '}
              {schema.projectVar5 ? schema.projectVar5.label : ''}{' '}
              {schema.projectVar5 ? <u> {schema.projectVar5.value || emptyValue} </u> : ''}{' '}
            </p>
          </Col>
        )}
      </Row>
    </>
  )
}
